import { render, staticRenderFns } from "./RoadmapPage.vue?vue&type=template&id=d12910c2&scoped=true&"
import script from "./RoadmapPage.vue?vue&type=script&lang=js&"
export * from "./RoadmapPage.vue?vue&type=script&lang=js&"
import style0 from "./RoadmapPage.vue?vue&type=style&index=0&id=d12910c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12910c2",
  null
  
)

export default component.exports